module.exports = __webpack_public_path__ + "lato-bold-d878b6c29b10beca227e9eef4246111b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-bold/lato-bold.woff
// module id = 1059
// module chunks = 0